import React, { useMemo } from 'react';
import { FileText } from 'lucide-react';
import PeriodFlowOverview from '../charts/PeriodFlowOverview';

const isCreditNote = (docType = '') =>
  String(docType || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .includes('credito');

const AccountingSalesOverview = ({
  documents = [],
  selectedPeriod = null,
  chartColumns = null,
  periodFilter = 'last_36',
  periodTitle = '',
  isDarkMode = false,
  ui,
  loading = false,
  children = null,
}) => {
  const flowRows = useMemo(
    () =>
      (documents || []).map((row) => {
        const total = Number(row.total_amount || 0);
        const credit = isCreditNote(row.document_type) || total < 0;
        const amount = Math.abs(total);
        const cancelled = String(row.status || '') === 'Anulada';
        return {
          date: row.doc_date,
          income: credit ? 0 : amount,
          expense: credit ? amount : 0,
          extraAmount: 0,
          extraCount: cancelled ? 1 : 0,
        };
      }),
    [documents]
  );

  return (
    <PeriodFlowOverview
      flowRows={flowRows}
      openingBalance={0}
      resetAtPeriodStart
      selectedPeriod={selectedPeriod}
      chartColumns={chartColumns}
      periodFilter={periodFilter}
      periodTitle={periodTitle}
      lineTitle="Total de ventas (c/IVA)"
      hoverPositiveLabel="Cargos"
      hoverNegativeLabel="Notas de crédito"
      totalLabel="Ventas (c/IVA)"
      positiveLabel="Cargos"
      negativeLabel="Notas de crédito"
      extraLabel="Documentos"
      extraIcon={FileText}
      extraMetric="count"
      extraHint={(current) =>
        current.extraCount
          ? `${current.extraCount.toLocaleString('es-CL')} anulada(s)`
          : `${current.count.toLocaleString('es-CL')} en el período`
      }
      isDarkMode={isDarkMode}
      ui={ui}
      loading={loading}
    >
      {children}
    </PeriodFlowOverview>
  );
};

export default AccountingSalesOverview;
